import { DesignData } from 'editor/src/store/design/types';
import { UploadedFontData } from 'editor/src/store/fonts/types';

import environment from 'editor/src/environment';

export interface ImportInDesignGalleryImage {
  id: string;
  name: string;
  type: string;
  width: number;
  height: number;
  state: string;
  url: string;
  thumbnailUrl: string;
}

export interface ImportInDesignWarning {
  code: string;
  message: string;
}

export interface ImportInDesignError {
  code: string;
  message: string;
}

export interface ImportInDesignSuccessResponse {
  status: 'success';
  galleryImages: ImportInDesignGalleryImage[];
  designData: DesignData;
  warnings: ImportInDesignWarning[];
  fonts: UploadedFontData[];
}

export interface ImportInDesignNeedsFitModeResponse {
  status: 'needs_fit_mode';
  fitOptions: string[];
  warnings: ImportInDesignWarning[];
}

export interface ImportInDesignErrorResponse {
  status: 'error';
  errors: ImportInDesignError[];
}

export type ImportInDesignResponse =
  | ImportInDesignSuccessResponse
  | ImportInDesignNeedsFitModeResponse
  | ImportInDesignErrorResponse;

interface Params {
  file: File;
  productUid: string;
  fitMode?: 'fit_inside' | 'fill_available_area';
}

const ENDPOINT = `${environment.preflightUrl.replace(/\/$/, '')}/product/editor/import-indesign`;

async function importInDesignApi({ file, productUid, fitMode }: Params): Promise<ImportInDesignResponse> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('product_uid', productUid);
  if (fitMode) {
    formData.append('fit_mode', fitMode);
  }

  const response = await fetch(ENDPOINT, {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    throw new Error(`Import failed with status ${response.status}`);
  }

  return response.json();
}

export default importInDesignApi;
